import { createElementBlock as r, openBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(a, e) {
  return t(), r("svg", o, [...e[0] || (e[0] = [
    l("path", {
      stroke: "currentColor",
      d: "M.5 10.5c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Z"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "m15.79 7.49-2.28-2.28a.715.715 0 0 0-1.01 0L6.21 11.5a.71.71 0 0 0-.21.506v2.28a.714.714 0 0 0 .714.714h2.28a.7.7 0 0 0 .505-.21l6.292-6.29a.715.715 0 0 0 0-1.01m-6.724 6.868a.1.1 0 0 1-.072.03h-2.28a.1.1 0 0 1-.102-.102v-2.28q0-.042.03-.072l4.562-4.562 2.424 2.424zm6.292-6.291L14.06 9.363 11.637 6.94l1.297-1.297a.103.103 0 0 1 .144 0l2.28 2.28a.1.1 0 0 1 .022.112.1.1 0 0 1-.022.033"
    }, null, -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
